import { CSSProperties } from "react";
import { twMerge } from "tailwind-merge";
import ReactMarkdown from "react-markdown";
import Spin from "@/shared/feedback/spin";
import { usePalette } from "@/shared/theme";
import {
  AiAssistantChatMessageFragment,
  AiAssistantChatRole,
} from "gql/graphql";
import { ToolCalls } from "@/modules/ai/features/ask-ai-assistant/views/tool-calls/tool-calls";

export function ChatMessage({
  message,
  stage,
}: {
  message: AiAssistantChatMessageFragment;
  stage?: string;
}) {
  const palette = usePalette();

  const isQuestion = message.role === AiAssistantChatRole.User;

  return (
    <div className={twMerge("flex", isQuestion && "justify-end")}>
      <div
        className={twMerge("border p-2 rounded bg-[--bg-color]")}
        style={
          {
            "--bg-color": isQuestion ? palette.primary[0] : palette.success[0],
          } as CSSProperties
        }
      >
        <span className={"block w-[250px] whitespace-pre-line break-words"}>
          <ToolCalls toolCalls={message.toolCalls} />

          {stage && (
            <span className={"flex items-center gap-2 text-xs opacity-70"}>
              <Spin size={"small"} />
              {stage}
            </span>
          )}

          <ReactMarkdown>{message.text}</ReactMarkdown>
        </span>
      </div>
    </div>
  );
}
